export default __webpack_public_path__ + "static/side-nav-do-3-d4ee343f2cfaec0c0f9c978dbc4d0b04afb147adad239887ccbbc8d02bfce797.png";